import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { updateContactApi } from "./contactApi";

export const updateContactRequest = createAsyncThunk(
  "updateContactRequest/contact",
  async (payload: any) => {
    try {
      const response = await updateContactApi(payload);
      return response;
    } catch (error) {
      throw error;
    }
  }
);

interface IInitialState {
  contactUpdate: any;
  message: string;
  pageIsLoading: boolean;
  isSuccess: boolean;
}

const initialState: IInitialState = {
  contactUpdate: {},
  message: "",
  pageIsLoading: false,
  isSuccess: false,
};

const contactSlice = createSlice({
  name: "contact",
  initialState: initialState,
  reducers: {
    resetContactMessage: (state) => {
      state.message = "";
    },
    resetContactSuccess: (state) => {
      state.isSuccess = false;
    },
  },
  extraReducers: (builder) => {
    // get job reducer
    builder.addCase(updateContactRequest.pending, (state) => {
      state.pageIsLoading = true;
    });
    builder.addCase(updateContactRequest.fulfilled, (state, action) => {
      if (action.payload.status === 1000) {
        state.contactUpdate = action.payload.data;
        state.isSuccess = true;
        state.pageIsLoading = false;
      } else {
        state.message = "someting went wrong";
        state.pageIsLoading = false;
      }
    });
    builder.addCase(updateContactRequest.rejected, (state) => {
      state.message = "someting went wrong on server";
      state.pageIsLoading = false;
    });
  },
});

export const { resetContactMessage, resetContactSuccess } =
  contactSlice.actions;
export default contactSlice.reducer;
